export const AppRoutes = {
  ROOT: '/',

  AUTH: '/auth',
  AUTH_LOGIN: '/auth/login',
  AUTH_LOGOUT: '/auth/logout',
  AUTH_FORGOT_PASSWORD: '/auth/forgot-password',

  NOTIFICATIONS: '/notifications',
  LEADS: '/contacts',
  USERS: '/users',
  ADMIN_EVENTS: '/admin/events',
  MANDATARY_EVENTS: '/mandatary/events',
  COMMISSION: '/lead-provider/commissions',
  LEAD_PROVIDER_REQUESTS: '/lead-provider/requests',
  PREFERENCES: '/preferences',

  CONSENT: '/consent',
  EVENT: '/event',
  FORBIDDEN: '/forbidden',
} as const;

export type AppRoute = (typeof AppRoutes)[keyof typeof AppRoutes];
